import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';
import {
  applyAnalyticsPendingLoading,
  markAnalyticsFetchKey,
} from '../../utils/analyticsQuery';

export const getChatGraphStats = createAsyncThunk(
  'chatGraphStats/getChatGraphStats',
  async ({ range = '30d', startDate = null, endDate = null, group_id }, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const business_id = loginToken?.response?.user?.business_id;

      // Build query params based on whether custom dates are provided
      let queryParams = '';
      if (startDate && endDate) {
        // Custom date range
        queryParams = `from=${startDate}&to=${endDate}&range=custom`;
      } else {
        // Predefined range
        queryParams = `range=${range}`;
      }
      if (group_id) {
        queryParams += `&group_id=${encodeURIComponent(group_id)}`;
      }

      const response = await axios.get(
        `${ROOT_URL}/chat-room/graph/${business_id}?${queryParams}`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`
          }
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  data: null,
  lastFetchKey: null,
  currentRange: '30d'
};

const getChatGraphStatsSlice = createSlice({
  name: 'getChatGraphStats',
  initialState,
  reducers: {
    resetChatGraphStatsState: (state) => {
      state.loading = false;
      state.error = null;
      state.data = null;
      state.lastFetchKey = null;
      state.currentRange = '30d';
    },
    setCurrentRange: (state, action) => {
      state.currentRange = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChatGraphStats.pending, (state, action) => {
        applyAnalyticsPendingLoading(state, action.meta?.arg);
        state.error = null;
      })
      .addCase(getChatGraphStats.fulfilled, (state, action) => {
        state.loading = false;
        markAnalyticsFetchKey(state, action.meta?.arg);
        state.data = action.payload.data;
        state.error = null;
      })
      .addCase(getChatGraphStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.data = null;
      });
  }
});

export const { resetChatGraphStatsState, setCurrentRange } = getChatGraphStatsSlice.actions;
export default getChatGraphStatsSlice.reducer; 